<div class="close-request-container">

  <div class="header">
    <div>{{title}} </div>
    <fi-button
      variant="tertiary"
      tone="neutral"
      size="lg"
      [iconOnly]="true"
      (click)="closeDialog()"
    >
      <mat-icon fiButtonIcon>close</mat-icon>
      <span fiTranslation="ALT_TEXT_DIALOG_CLOSE"></span>
    </fi-button>
  </div>

  <div class="main-container">
    <div class="form">
      <div class="row">
        <fi-input
          labelKey="ACTION_NOT_INTERESTED_HEADLINE_END_BY"
          type="SELECT"
          [multiLineOptionText]="true"
          [wrap]="true"
          [sectionTextKeys]="sectionTextKeys"
          [options]="allOptions"
          namePropertyPath="Description"
          (onChange)="selectResultItem($event)"
          >

        </fi-input>

        @if (detailOptions.length) {
          <fi-input
            [labelKey]="detailCaption"
            type="SELECT"
            placeholderKey="ACTION_NOT_INTERESTED_PLACEHOLDER_PRICE_DEVIATION"
            namePropertyPath="Text"
            [options]="detailOptions"
            [selectedOptionsOrValues]="notInterestedDetailId"
            (onChange)="selectNotInterestedDetail($event)"
            >
          </fi-input>
        }
      </div>

      <div>
        <div class="field-title">
          <span fiTranslation="ACTION_GENERAL_HEADLINE_REQUEST_NOTE2"></span>@if (selectedTypeName === 'CONTACT_OTHER' || selectedTypeName === 'FINSTRAL_OTHER') {
          <span>*</span>
        }
      </div>
      <fi-editor
        [noUploads]="true"
        [placeholderTranslation]="'REQUEST_DETAIL_NOTE_PLACEHOLDER'"
        (isLongDescription)="inValidNote = $event"
        (textChanged)="note = $event">
      </fi-editor>
    </div>
  </div>
</div>

<div class="footer">
  <button (click)="submit()" [disabled]="!formIsValid">
    <img [src]="iconUrl" alt="Action icon">
    <span> {{title}} </span>
  </button>
</div>

</div>
